export default [

  {
    path: "/refunds/list",
    name: "refunds-list",
    component: () => import("@/views/refund/refunds-list/refundsList.vue"),
    meta: {
      action: ['read', 'read_all'], 
      resource: "refunds",
    },
  },
  {
    path: "/refund/edit/:id",
    name: "refund-edit",
    component: () => import("@/views/refund/refund-edit/refundEdit.vue"),
    meta: {
      action: "update",
      resource: "refunds",
    },
  },
  {
    path: "/refund/copy/:id",
    name: "refund-copy",
    component: () => import("@/views/refund/refund-edit/refundEdit.vue"),
    meta: {
      action: "create",
      resource: "refunds",
    },
  },
  {
    path: "/refund/create",
    name: "refund-create",
    component: () => import("@/views/refund/refund-edit/refundEdit.vue"),
    meta: {
      action: "create",
      resource: "refunds",
    },
  },
  {
    path: "/refund/customer-create",
    name: "refund-customer-create",
    component: () => import("@/views/refund/refund-edit/refundEdit.vue"),
    meta: {
      action: "create",
      resource: "refunds",
    },
  },
  {
    path: '/refund/preview/:id',
    name: 'refund-preview',
    component: () => import('@/views/refund/refund-preview/RefundPreview.vue'),
    meta: {
      action: 'print',
      resource: 'refunds',
    },
  },
]